import React, { useState } from "react";
import styles from "./deletemodal.module.css";

function DeleteModal({close, user, objectId, objectName, deleteFunction, changeActivity, reason, userActivity}) {

    const [reasonInput, setReasonInput] = useState("");
    const [isPoppedOut, setIsPoppedOut] = useState(false);

    async function handleDelete() {
        const res = reason ? await deleteFunction(objectId, reasonInput) : await deleteFunction(objectId);
        if (res[0] === 200) close("");
    }

    async function handleActivity() {
        const res = reason ? await changeActivity(objectId, reasonInput) : await changeActivity(objectId);
        if (res[0] === 200){
            setIsPoppedOut(true);
            setTimeout(() => {
                close("");
            }, 250);
        }
    }

    function handleClose() {
        setIsPoppedOut(true);
        setTimeout(() => {
            close("");
        }, 250);
    }

    return (
        <div className={`${styles.bodyDelete} ${isPoppedOut ? styles.popout : styles.popin}`}>
            <div className={styles.center}>
                <div className={styles.column}>
                    {
                        user ?
                            <h4 style={{margin:0}}>Deseja eliminar ou {userActivity ? "desativar" : "ativar"} {objectName} ?</h4>
                        :
                            <h4 style={{margin:0}}>Deseja eliminar {objectName} ?</h4>
                    }
                    <div className={styles.buttons}>
                        {
                            reason ? 
                                <div className={styles.formBlockSection}>
                                    <p>Motivo:</p>
                                    <input onChange={(e) => setReasonInput(e.target.value)}/>
                                </div>
                            : ""
                        }
                        {
                            user ?
                                <button className={styles.actionButton} onClick={() => handleActivity()}>
                                    Sim, {userActivity ? "desativar" : "ativar"}
                                </button>
                            : ""
                        }
                        <button className={styles.actionButton} onClick={() => handleDelete()}>
                            Sim, {userActivity ? "desativar e " : ""} eliminar
                        </button>
                        <button className={styles.backButton} onClick={() => handleClose()}>
                            Não, voltar
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default DeleteModal;